<div class="mat-typography">
  <app-toolbar
    [authenticationStatus]="appFacade.authenticationStatus$ | async"
    [bookingPhoneNumber]="(appFacade.selectedOrganizationRiderListItem$ | async)?.bookingPhoneNumber"
    [shouldShowHelpButton]="!(appFacade.isRiderIneligible$ | async) && (appFacade.isInitialOrganizationRiderListItemsLoaded$ | async)"
    [showTabs]="!(appFacade.isRiderIneligible$ | async)"
    (logoutButtonClicked)="handleLogout()"
  ></app-toolbar>

  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
